// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BackToTopController from "./back_to_top_controller"
application.register("back-to-top", BackToTopController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import CopyToClipboardController from "./copy_to_clipboard_controller"
application.register("copy-to-clipboard", CopyToClipboardController)

import CropperController from "./cropper_controller"
application.register("cropper", CropperController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmojiController from "./emoji_controller"
application.register("emoji", EmojiController)

import FlappyBirdController from "./flappy_bird_controller"
application.register("flappy-bird", FlappyBirdController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GameSliderImageController from "./game_slider_image_controller"
application.register("game-slider-image", GameSliderImageController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImgSliderController from "./img_slider_controller"
application.register("img-slider", ImgSliderController)

import LightGalleryController from "./light_gallery_controller"
application.register("light-gallery", LightGalleryController)

import LimitGamesController from "./limit_games_controller"
application.register("limit-games", LimitGamesController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PostCommentController from "./post_comment_controller"
application.register("post-comment", PostCommentController)

import ScrollUpController from "./scroll_up_controller"
application.register("scroll-up", ScrollUpController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SnakeController from "./snake_controller"
application.register("snake", SnakeController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import YtStatusController from "./yt_status_controller"
application.register("yt-status", YtStatusController)
